import { useFormikContext } from "formik";
import { shape } from "prop-types";

import __ from "web/Layout/Translations";

import GoogleSearch from "./GoogleSearch";
import classes from "./localization.scss";

const ProductLocalizationMobile = ({ field }) => {
  const { values } = useFormikContext();
  const locationValue = values && values[field.name];

  return (
    <div className={classes.root}>
      <div className={classes.fieldset}>
        <strong className={classes.legend}>{__("Lokalizacja")}</strong>
        <GoogleSearch
          name={field.name}
          placeholder={field.placeholder}
          initialValue={locationValue || ""}
        />
      </div>
    </div>
  );
};

ProductLocalizationMobile.propTypes = {
  field: shape({}).isRequired,
};

export default ProductLocalizationMobile;
